exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer{\r\n\tposition: relative;\r\n    box-sizing: border-box;\r\n\ttop: 10px;/*always make footer at underground*/\r\n    bottom: 0;/*always make footer at underground*/\r\n\tclear: both;/*always make footer at underground*/\r\n}\t\r\n\r\n.footer, .footer a{\r\n\tcolor: #49494a;\r\n\ttext-decoration: none;\r\n\tfont-size: 14px;\r\n}\r\n.footer a:hover{\r\n\tcolor: #ae6666;\r\n}\r\n.footer-bar {\r\n\tcolor: #c90404;\r\n\tfont-weight: 600;\r\n}\r\n.company-area{\r\n\twidth: inherit;\r\n\tmax-height: 306px;\r\n\tmargin: 2px 15px 58px 15px;\r\n\toverflow: auto;\r\n}\r\n@media(min-width: 768px) {\r\n\t.company-area{\r\n\t\twidth: 638px;\r\n\t}\r\n\r\n}\r\n@media(min-width: 992px) {\r\n\t.company-area{\r\n\t\twidth: 834px;\r\n\r\n\r\n\t}\r\n\r\n}\r\n@media(min-width: 1200px) {\r\n\t.company-area{\r\n\t\twidth: 970px;\r\n\t}\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader?{"ident":"postcss"}!./src/assets/css/footer.css
// module id = ./node_modules/css-loader/index.js?{"sourceMap":false,"importLoaders":1}!./node_modules/postcss-loader/index.js?{"ident":"postcss"}!./src/assets/css/footer.css
// module chunks = 2